jQuery(document).ready(function($) {

	let winWidth = $(window).width();

	if ( winWidth < 992 ) {

		$('.insight--anchor-toggle').on('click',function(e) {

			e.preventDefault();
			$('.insight--anchors').toggleClass('is-expanded');

		});

	  	$('.insight--anchor a').on('click',function(e) {

			let parent = $(this).parent();
			$('.insight--anchor').removeClass('active');
			$(this).parent().addClass('active');
			$('.insight--anchors').removeClass('is-expanded');

		});

	}

});
